<template>
  <div class="home">
    <topmenu @refresh="refresh" @add="onAdd"/>
    <section class="section">
      <div class="container">
        <div class="last-day">
          <b-table
            :data="services"
            :selected.sync="selected"
            striped
            hoverable
          >
            <template slot-scope="props">
                <b-table-column field="index" label="№" width="40" numeric>
                    {{ props.index + 1 }}
                </b-table-column>
                <b-table-column field="name" label="Имя">
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column field="price" label="Цена">
                    {{ props.row.price }}
                </b-table-column>

                <b-table-column field="edit" label="Изменить" centered>
                  <button class="button is-small" @click="edit(props.row)">
                    <b-icon icon="account-edit"></b-icon>
                  </button>
                  <button class="button is-small mgl-1" @click="remove(props.row)">
                    <b-icon icon="delete"></b-icon>
                  </button>
              </b-table-column>
              
            </template>
          </b-table>
        </div>
      </div>
    </section>

    <b-modal :active.sync="addModalShow" has-modal-card>
      <section>
        <div class="modal-bg">
          <b-field>
            <b-input placeholder="Имя" v-model="name"></b-input>
          </b-field>
          <b-field>
            <b-input placeholder="цена" v-model="price"></b-input>
          </b-field>
          <div class="control">
            <button class="button is-link" @click="addCService()">отправить</button>
          </div>
        </div>
      </section>
    </b-modal>

    <div class="add-fixed-button">
      <b-button type="is-info" @click="addModalShow = true" icon-left="plus" />
    </div>
  </div>
</template>

<script>
import topmenu from "@/components/menu.vue";
import { api } from "@/api";
import { mapActions } from "vuex";

export default {
  name: "home",
  data() {
    return {
      services: [],
      addModalShow: false,
      selected: null,
      name: '',
      price: '',
      editId: null
    };
  },
  methods: {
    ...mapActions(['submitService', 'getServices']),

    onAdd() {
      this.edit({id: null, name: '', price: ''})
    },

    
    refresh() {
      this.getData()
    },

    edit(row) {
      this.editId = row.id;
      this.name = row.name;
      this.price = row.price;
      this.addModalShow = true
    },

    async remove(row) {
      await this.$buefy.dialog.confirm({
        message: "Видалити послугу",
        onConfirm: async () =>
          await api({
            method: "delete",
            point: `services/${row.id}`
          })
      });

      this.refresh();
    },


    async addCService() {
      if (this.name.length > 0 && Number(this.price) > 0) {
        await this.submitService({
          id: this.editId,
          name: this.name,
          price: Number(this.price)
        })
        this.addModalShow = false
        this.refresh()
        return;
      }
      this.$buefy.snackbar.open({
        duration: 5000,
        message: 'Проверте данные!',
        type: 'is-warning',
        position: 'is-bottom',
        actionText: 'Ок'
      })
    },
    async getData() {
      await this.getServices().then(res => {
        this.services = res
      })
    }
  },
  mounted() {
    this.getData()
  },
  components: {
    topmenu
  }
};
</script>
